import analytics from 'analytics';
import mixpanel from 'mixpanel-browser';

import { mixpanelPlugin } from 'src/services/analytics/plugins/mixpanel';
import { Auth } from 'src/services/api';

const baseAnalyticsClient = analytics({
    app: import.meta.env.VITE_APP_NAME,
    plugins: [mixpanelPlugin]
});

export const analyticsClient = {
    track: (event: string, properties?: any) => {
        const userUuid = Auth.loggedInUser?.uuid?.toString();
        const userEmail = Auth.loggedInUser?.email;
        const userName = Auth.loggedInUser?.name;
        const isLoginAs = !!Auth.jwtPayload?.dl;
        if (userUuid) {
            baseAnalyticsClient.identify(userUuid);
            // Set user properties directly in Mixpanel
            mixpanel.people.set({
                $email: userEmail,
                $name: userName,
                $is_login_as: isLoginAs,
            });
        }
        return baseAnalyticsClient.track(event, {
            ...properties,
            $email: userEmail,
            $name: userName,
            $is_login_as: isLoginAs,
        });
    },
    page: (properties?: any) => {
        const userUuid = Auth.loggedInUser?.uuid?.toString();
        const userEmail = Auth.loggedInUser?.email;
        const userName = Auth.loggedInUser?.name;
        const isLoginAs = !!Auth.jwtPayload?.dl;
        if (userUuid) {
            baseAnalyticsClient.identify(userUuid);
            // Set user properties directly in Mixpanel
            mixpanel.people.set({
                $email: userEmail,
                $name: userName,
                $is_login_as: isLoginAs,
            });
        }
        return baseAnalyticsClient.page({
            ...properties,
            $email: userEmail,
            $name: userName,
            $is_login_as: isLoginAs,
        });
    },
    identify: (userId: string) => {
        return baseAnalyticsClient.identify(userId);
    }
};